import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useLocation } from 'react-router';
import { APP_ROUTES } from '../../constants/appRoutes';

import ok from '../../assets/icons/ok.svg';
import notOk from '../../assets/icons/notOk.svg';
import girl from '../../assets/girl.png';
import girlPortrait from '../../assets/girlPortrait.png';
import girlBlack from '../../assets/girlBlack.png';
import girlPortraitBlack from '../../assets/girlPortraitBlack.png';
import girlSepia from '../../assets/girlSepia.jpg';
import girlPortraitSepia from '../../assets/girlPortraitSepia.jpg';
import girlPopArt from '../../assets/girlPopArt.jpg';
import girlPortraitPopArt from '../../assets/girlPortraitPopArt.jpg';

import girlEmbroidery from '../../assets/girlEmbroidery.png';
import girlDotPainting from '../../assets/girlDotPainting.png';
import girlPortraitDotPainting from '../../assets/girlPortraitDotPainting.png';
import girlPortraitEmbroidery from '../../assets/girlPortraitEmbroidery.png';
import styles from './styles.module.scss';
import Button from '../../components/Button';
import { ProductTypes } from '../../types/enums';
import { PhotoContext } from '../../context/PhotoProvider';
import NavButton from '../../components/NavButton';

const routesMap = {
  [ProductTypes.EMBROIDERY]: {
    next: (isNavigateToEmail: boolean) =>
      isNavigateToEmail
        ? APP_ROUTES.UPLOAD_EMBROIDERY_PHOTO_WITH_CODE
        : APP_ROUTES.UPLOAD_EMBROIDERY_PHOTO,
    back: (isNavigateToEmail: boolean) =>
      isNavigateToEmail
        ? APP_ROUTES.EMBROIDERY_INSTRUCTION
        : APP_ROUTES.CHOOSE_SIZE_EMBROIDERY,
    tittle: 'howToChoosePhotoForTheEmbroidery',
    girlImg: [girlEmbroidery],
    girlPortraitImg: [girlPortraitEmbroidery],
  },
  [ProductTypes.MOSAIC]: {
    next: (isNavigateToEmail: boolean) =>
      isNavigateToEmail
        ? APP_ROUTES.UPLOAD_PHOTO_WITH_CODE
        : APP_ROUTES.UPLOAD_PHOTO,
    back: (isNavigateToEmail: boolean) =>
      isNavigateToEmail
        ? // APP_ROUTES.INSTRUCTION
          APP_ROUTES.CHOOSE_STYLE
        : APP_ROUTES.CHOOSE_SIZE_DIAMOND_PHOTO_MOSAIC,
    tittle: 'howToChoosePhotoForTheMosaic',
    girlImg: [girlBlack, girlSepia, girlPopArt],
    girlPortraitImg: [girlPortraitBlack, girlPortraitSepia, girlPortraitPopArt],
  },
  [ProductTypes.PAINTING]: {
    next: () => APP_ROUTES.CATALOGUE,
    back: () => APP_ROUTES.CATALOGUE,
    tittle: 'howToChoosePhotoForThePainting',
    girlImg: [girlBlack],
    girlPortraitImg: [girlPortraitBlack],
  },
  [ProductTypes.DOT_PAINTING]: {
    next: (isNavigateToEmail: boolean) =>
      isNavigateToEmail
        ? APP_ROUTES.UPLOAD_DOT_PAINTING_PHOTO_WITH_CODE
        : APP_ROUTES.UPLOAD_DOT_PAINTING_PHOTO,
    back: (isNavigateToEmail: boolean) =>
      isNavigateToEmail
        ? APP_ROUTES.DOT_PAINTING_INSTRUCTION
        : APP_ROUTES.CHOOSE_SIZE_DOT_PAINTING,
    tittle: 'howToChoosePhotoForThePainting',
    girlImg: [girlDotPainting],
    girlPortraitImg: [girlPortraitDotPainting],
  },
};
const HowToChoosePhoto = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const props = location.state;
  const { productType, styleVariant, setStyleVariant } =
    useContext(PhotoContext);

  const navigateToUpload = () => {
    navigate(routesMap[productType].next(!!props?.navigateToEmail));
  };
  const navigateBack = () => {
    setStyleVariant(1);
    navigate(routesMap[productType].back(!!props?.navigateToEmail));
  };

  return (
    <div>
      <h1 className={styles.title}>{t('How to choose a photo?')}</h1>
      <h4 className={styles.description}>
        {t(
          'We recommend focusing on close-up shots of large subject, like the face, and avoiding plain backgrounds.',
        )}
      </h4>
      <div className={styles.wrapper}>
        <div className={styles.photos}>
          <div className={styles.photo_set}>
            <img
              className={styles.photo_element}
              src={girlPortrait}
              alt="girl portrait"
            />
            <img src={ok} className={styles.icon_element} alt="ok" />
            <img
              className={styles.photo_element}
              src={
                routesMap[productType].girlPortraitImg[
                  styleVariant ? styleVariant - 1 : 0
                ]
              }
              alt="girl portrait black"
            />
          </div>
          <div className={styles.photo_set}>
            <img className={styles.photo_element} src={girl} alt="girl" />
            <img src={notOk} className={styles.icon_element} alt="not ok" />
            <img
              className={styles.photo_element}
              src={
                routesMap[productType].girlImg[
                  styleVariant ? styleVariant - 1 : 0
                ]
              }
              alt="girl black"
            />
          </div>
        </div>

        {props?.navigateToEmail ? (
          <div className={styles.navButtons}>
            <NavButton type="back" text="Back" onClick={navigateBack} />
            <NavButton type="next" text="Next" onClick={navigateToUpload} />
          </div>
        ) : (
          <div className={styles.buttons}>
            <h2 className={styles.subtitle}>
              {t("I've already prepared a suitable photo")}
            </h2>
            <Button text="Show" onClick={navigateToUpload} />
          </div>
        )}
      </div>
    </div>
  );
};

export default HowToChoosePhoto;
